module.exports = __webpack_public_path__ + "img/idx-service-shield.5903631.webp";